class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.timezone = this.dataset.timezone || 'Australia/Adelaide';
    this.daysElement = this.querySelector('.countdown-timer__days');
    this.hoursElement = this.querySelector('.countdown-timer__hours');
    this.minutesElement = this.querySelector('.countdown-timer__minutes');
    this.updateTimer = this.updateTimer.bind(this);
  }

  connectedCallback() {
    this.updateTimer();
    this.interval = setInterval(this.updateTimer, 60000); // Update every minute
  }

  disconnectedCallback() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  getNextSunday() {
    const now = new Date();
    const adelaideTime = new Date(now.toLocaleString('en-US', { timeZone: this.timezone }));
    const dayOfWeek = adelaideTime.getDay();
    const daysUntilSunday = dayOfWeek === 0 ? 
      (adelaideTime.getHours() >= 23 && adelaideTime.getMinutes() >= 59 ? 7 : 0) : 
      (7 - dayOfWeek);
    
    const nextSunday = new Date(adelaideTime);
    nextSunday.setDate(adelaideTime.getDate() + daysUntilSunday);
    nextSunday.setHours(23, 59, 0, 0);
    
    return nextSunday;
  }

  updateTimer() {
    const now = new Date();
    const adelaideTime = new Date(now.toLocaleString('en-US', { timeZone: this.timezone }));
    const nextSunday = this.getNextSunday();
    
    const timeDiff = nextSunday - adelaideTime;
    const daysRemaining = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
    const hoursRemaining = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutesRemaining = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
    
    const totalHours = (daysRemaining * 24) + hoursRemaining;
    
    // Only show if less than 6 days (144 hours) remain
    if (totalHours <= 144) {
      this.style.display = 'block';
      this.daysElement.textContent = daysRemaining;
      this.hoursElement.textContent = hoursRemaining;
      this.minutesElement.textContent = minutesRemaining;
    } else {
      this.style.display = 'none';
    }
  }
}

customElements.define('countdown-timer', CountdownTimer);
